import { Component, Input, ViewChild } from '@angular/core';
import { App, Events, LoadingController, NavController, NavParams, PopoverController, ViewController } from 'ionic-angular';
import { AnonymousSubject } from 'rxjs';
import { EventProvider, Pager, RouteInfos } from '../../../../providers/event/event';
import { PublicProfileModel, UserProvider } from '../../../../providers/user/user';
import L from 'leaflet';
import 'leaflet.offline';
import { LeafletCreator } from '../../../../tracker/map-factory/map-factory';
import { LocationHandlerUtil } from '../../../../tracker/location-handler-utils';
import { ResultProfilePage } from '../../../results/result-profile/result-profile';
import { TranslateService } from '@ngx-translate/core';
import { ValueProvider } from '../../../../providers/value/value';
import { PopoverFeedComponent } from '../../../../components/popover-feed/popover-feed';
import { SessionProvider } from '../../../../providers/session/session';
import { MysportPhotosPage } from '../../../me/mysport/mysport-photos/mysport-photos';
import { TrophyComponent } from '../../../../components/trophy/trophy';
import { eventCategories } from '../../../../assets/data/categories/categories';
import { ThemeMode } from '../../../../providers/dark-mode/dark-mode';

declare var google;

@Component({
  selector: 'page-activity-friends',
  templateUrl: 'activity-friends.html'
})
export class ActivityFriendsPage {
  urlTemplate = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
  pager = { page: 1, start: 25, limit: 25 };
  feeds: FeedResponse[] = [];
  tab: string = "activity";
  toolbarReady: boolean = false;
  option:any=null;
  loading: boolean = true;
  profile:any;
  @ViewChild('trophy')
  trophyComponent: TrophyComponent;
  themeMode;

  @Input() trophySwapper;
  @Input('internal') isInternalFeed: boolean = false;
  @Input('isFriendFeed') isFriendFeed: boolean = false;
  @Input('spId') spId;
  sportHeroName:string='';
  result = {
    athleteId: 11785797,
    athleteName: "Maurice Clavel",
    cid: 295,
    commentCount: 1,
    eventDate: 1439078400000,
    eventId: 7592962,
    eventName: "Ironman 70.3 Germany",
    fanCount: 1,
    gplatz: 12,
    gtime: 15410,
    hasDatum: true,
    hasPlatz: true,
    hasStrecke: true,
    hasZeit: true,
    hitCount: 0,
    id: 7592975,
    lid: -1,
    picName: "https://spooorts.de/d/med/295/7592975/",
    resultText: "Platz 12 in 04:16:50 über 1,9-90-21,098km",
    strecke1: 1900,
    strecke2: 90000,
    strecke3: 21098,
    streckeconv: "1,9-90-21,098km",
    trophyColor: "1",
    trophyMaterial: "1",
    trophyType: "Pokal Gold"
  };
  noActivitiesMessage:string ="";
  noData = false;
  constructor(
    private navCtrl: NavController,
    private userService: UserProvider,
    private eventService: EventProvider,
    private eventsListener: Events,
    private loadingCtrl: LoadingController,
    private translate: TranslateService,
    private valueService: ValueProvider,
    private app: App,
    private popoverCtrl: PopoverController,
    private sessionService: SessionProvider,
    private navParams:NavParams,
    private viewCtrl: ViewController) 
  {
    this.noActivitiesMessage = this.translate.instant('NO_ACTIVITIES');
    this.themeMode= JSON.parse(localStorage.getItem('darkMode') || `"${ThemeMode.LightMode}"`) as ThemeMode;
  }

  ngAfterViewInit() {
    if(this.isInternalFeed){
      this.profile = this.sessionService.profile
      this.sportHeroName = `${this.profile.forName} ${this.profile.surName}`
      this.initInternalFeed();
    }
    if(typeof this.trophySwapper!=="undefined"){
      this.trophySwapper.subscribe((i) => {
        this.trophyComponent.switch(this.feeds[i].result);
      });
    }
    if(!this.isInternalFeed){
      this.feeds = this.navParams.get('feeds');
      console.log('feeds',this.feeds)
      if(!this.feeds){
        this.feeds = null
      }
      else{
        this.feeds.forEach(f => f.hasRoute = false);
        this.processFeeds();
      }
    }
  }

  onDismiss(option) {
    this.viewCtrl.dismiss(option);
  }

  onBackMenu() {
    this.onDismiss(this.option);
  }
  onPopver(ev, feed) {
    console.log('feed: ', feed);
    let popover = this.popoverCtrl.create(PopoverFeedComponent);
    popover.present({
      ev: ev
    });

    popover.onDidDismiss((entry) => {
      (entry > 0) ? this.showRoutePhotos(feed) : this.unfollow(feed.lid);
    })
  }

  showRoutePhotos(feed) {
    let loader = this.loadingCtrl.create({});
    loader.present();
    this.sessionService.getToken().then(token => {
      this.eventService.getRoutePrics(token, "testRoute").then((pics) => {
        loader.dismiss();
        // if (pics.length > 0) 
        this.navCtrl.push(MysportPhotosPage, { pictures: pics, type: "route-no-button" });
      });
    });
  }

  unfollow(userId) {
    this.userService.removeFriend(userId).then((result) => console.log(result));
  }

  initInternalFeed() {
    if(this.feeds.length == 0){
      setTimeout(() => {
        console.log('this.isFriendFeed: ', this.isFriendFeed);
        this.userService.getMyFeed(this.pager.page, this.pager.start, this.pager.limit, this.isFriendFeed, this.spId).then((feeds: FeedResponse[]) => {
          this.feeds = Object.assign([], feeds);
          this.feeds.forEach(f => f.hasRoute = false);
          this.processFeeds();
        });
      }, 400);
    }
  }
  processFeeds() {
    for (let i = 0; i < this.feeds.length; i++) {
      if (this.feeds[i].result==null && this.feeds[i].training==null){
        this.loading = false;
        this.feeds.length=0
        this.noData = true
        return 
      }
      // if (this.feeds[i].result || this.feeds[i].distance || this.feeds[i].training.contents.length == 0) continue;

      this.feeds[i].baseLayer = null;
      this.feeds[i].map = null;
      this.feeds[i].control = null;
      // this.feeds[i].id = "leaflet" + i;
      this.feeds[i].id = "leaflet" + new Date().getTime() + i;
      this.feeds[i].hasRoute = true;
    }

    setTimeout(() => {
      for (let i = 0; i < this.feeds.length; i++) {
        if(this.feeds[i].route){
          const str = this.feeds[i].route.routeName;
          const dFormated = str.split(' ')
          if(dFormated[2]){
            // this.feeds[i].training.dtFormatted
            this.feeds[i].training.dtFormatted = `${dFormated[1]}, ${dFormated[2]}`
          }
        }
        this.feeds[i].passResult = { id: this.feeds[i].result ? this.feeds[i].result.id : this.feeds[i].training.id };
        let cid;
        const training = this.feeds[i].training;
        if (training?.sportArt){
          cid = eventCategories.find(category => category.name.includes(this.feeds[i].training.sportArt));          
        }
        // this.feeds[i].passResult = { id: this.feeds[i].result ? this.feeds[i].result.id : this.feeds[i].training.id };
        this.feeds[i].passResult.cid = (typeof cid === "undefined") ? -1 : cid.id;
        this.loadLeafletMaps(this.feeds[i].id, i).then(() => {
          this.feeds[i].altitude = 0;
          this.feeds[i].mapHandler = new LeafletCreator(this.feeds[i].map);
          if(/\d/.test(this.feeds[i].training.title)|| /[a-zA-Z]/.test(this.feeds[i].training.title)){
            this.feeds[i].training.title = ""
          }
          this.feeds[i].path = this.feeds[i].training ? this.combinePath(this.feeds[i].training.title) : [];
          this.feeds[i].distance = this.feeds[i].training ? this.feeds[i].training.distanceMeter / 1000 : 0;
          this.feeds[i].elevation = this.feeds[i].training ? this.calcTotalAltitude(this.feeds[i].training.title) : 0;
          // this.eventsListener.publish('fan:update');
            if(this.feeds[i].route!==null){
              this.drawLines(this.feeds[i]);
            }
          this.boundLeaflet(this.feeds[i]);
        });
      }
      this.toolbarReady = true;
    }, 400);
    this.loading = false;
  }

  showSportProfile(r) {
    let loader = this.loadingCtrl.create({ content: this.translate.instant('GLOBAL_LOADING') });
    loader.present();

    this.valueService.getProfileBackgrounds().then(backgrounds => {
      // this.userService.getPublicProfile(r.result.athleteId).then((value: PublicProfileModel) => {
      //   (this.app.getRootNav() as NavController)
      //     .push(ResultProfilePage, { profile: value, backgrounds: backgrounds, result: r.result })
      //     .then(() => loader.dismiss());
      // });
    });
  }

  loadNextPage() {
    this.pager.page = this.pager.page + 1;
    this.pager.start = this.pager.start + 25;

    this.userService.getMyFeed(this.pager.page, this.pager.start, this.pager.limit, this.isFriendFeed, this.spId).then((feeds: FeedResponse[]) => {
      feeds.forEach(f => f.hasRoute = false);
      this.feeds = this.feeds.concat(feeds);
      console.log(this.feeds);
      this.processFeeds();
    });
  }

  boundLeaflet(route) {
    let markerArray = [];
    for (let i = 0; i < route.path.length; i++) {
      markerArray.push(L.marker([route.path[i][0], route.path[i][1]]));
    }
    let center = route.mapHandler.getCenter();
    markerArray.push(L.marker([center.lat, center.lng]));
    let group = L.featureGroup(markerArray);
    route.map.fitBounds(group.getBounds());
  }
  drawLines(route) {
    let activeItem = route.route
    if(activeItem.routeData.length>0){
      let routeInfos = JSON.parse(activeItem.routeData) as RouteInfos;
      activeItem.path = google.maps.geometry.encoding.decodePath(routeInfos.routeInfos[0].path)
      route.mapHandler.newPoly();
      route.mapHandler.setPolyDestinations(activeItem.path);
      route.mapHandler.drawPolyLines(true);
      route.mapHandler.setMapCenterLatLng(activeItem.path[0]);
    }
  }

  combinePath(encodedURI: string) {
    if (encodedURI) {
      let decoded = JSON.parse(decodeURI(encodedURI));
      let path = decoded.map(x => x.coords);
      return path;
    }
    return [];
  }

  calcTotalAltitude(encodedURI: string) {
    if (encodedURI) {
      let decoded = JSON.parse(decodeURI(encodedURI));
      let elevation = Math.floor(decoded.map(x => x.elevation).reduce((acc, cur) => acc + cur, 0) / 1000);
      return elevation;
    }
    return 0;
  }

  loadLeafletMaps(id, index) {
    return new Promise<any>((resolve, reject) => {
      let map = (L as any).map(id);
      if(map){
        let baseLayer = (L as any).tileLayer
        .offline(this.urlTemplate, {
          attribution: 'Map data {attribution.OpenStreetMap}',
          subdomains: 'abc',
          minZoom: 1,
        })
        .addTo(map);

        map.setView(
          {
            lat: 52.5204345,
            lng: 13.4014027,
          },
          19
        );
        let that = this;
        let control = (L as any).control.savetiles(baseLayer, {
          zoomlevels: [19, 19], // optional zoomlevels to save, default current zoomlevel
          confirm(layer, successCallback) {
            console.log('layer: ', layer);
            successCallback();
          },
          confirmRemoval(layer, successCallback) {
            if (window.confirm('Remove all the tiles?')) {
              successCallback();
            }
          },
          saveText:
            '<i class="fa fa-download" aria-hidden="true" title="Save tiles"></i>',
          rmText: '<i class="fa fa-trash" aria-hidden="true"  title="Remove tiles"></i>',
        });
        control.addTo(map);

        let progress;
        baseLayer.on('savestart', (e) => {
          console.log('e: ', e);
          progress = 0;
          console.log(e._tilesforSave.length);
        });
        baseLayer.on('savetileend', () => {
          progress += 1;
          console.log("progress: " + progress);
        });

        this.feeds[index].map = map;
        this.feeds[index].baseLayer = baseLayer;
        this.feeds[index].control = control;
      }
      resolve(null);
    });
  }

  viewOnStrava(){}


  // imagePath: ""
  // result: null
  // spId: 5546010
  // sportHeroName: "Klausi Lewerenz"
  // training: {sportArt: 'Laufen', dt: 1628529478000, dtFormatted: '17:17', trainType: null, cid: 16, …}
  // usrImgPath: "https://spooorts.de/d/usr/20199/0.jpg"
}

export interface FeedResponse {
  imagePath: any;
  result: any;
  passResult: any;
  spId: number;
  sportHeroName: string;
  training: any;
  usrImgPath: string;
  distance?: any;
  altitude?: any;
  hasRoute?: boolean;
  mapHandler?: any;
  baseLayer?: any;
  map?: any;
  elevation?: any;
  control?: any;
  id?: any;
  path?: any;
  route:any;

}



// WEBPACK FOOTER //
// /src/pages/event/event-activity-tabs/activity-friends/activity-friends.ts